<template>
  <div class="basic_wrap">
    <div class="page_header">
      <div class="header_inner">
        <div class="back_left" @click="$router.back()"></div>
        <div class="big_tit">卡密信息</div>
        <div class="header_action" @click="selectMode ? exitSelectMode() : enterSelectMode()">
          {{ selectMode ? '取消' : '选择' }}
        </div>
      </div>
    </div>

    <div class="content_box" :class="{ 'has_footer': selectMode }">
      <van-dropdown-menu class="filter_menu" active-color="#5b8cff">
        <van-dropdown-item v-model="filterVerified" :options="verifiedOptions" @change="onFilterChange" />
        <van-dropdown-item v-model="filterHasCard" :options="hasCardOptions" @change="onFilterChange" />
      </van-dropdown-menu>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length === 0 ? '' : '没有更多了'"
          @load="onLoad"
        >
          <van-empty v-if="!loading && list.length === 0" description="暂无卡密信息" />

          <div
            v-for="item in list"
            :key="item.id"
            class="kami_card"
            :class="{ 'in_select': selectMode }"
            @click="selectMode && isSelectable(item) && toggleCheck(item)"
          >
            <div class="card_head">
              <div
                v-if="selectMode && isSelectable(item)"
                class="check_icon"
                :class="{ checked: item.checked }"
                @click.stop="toggleCheck(item)"
              >
                <van-icon v-if="item.checked" name="success" />
              </div>
              <p class="item_title van-multi-ellipsis--l2">{{ item.item_title || '商品名称' }}</p>
              <div class="head_btns">
                <van-icon
                  v-if="item.categoryName || item.cardTypeName || item.faceValue"
                  name="info-o"
                  class="info_icon"
                  @click.stop="showMeta(item)"
                />
                <div v-if="item.cardText" class="copy_all_btn" @click.stop="copyText(item.cardText)">复制</div>
              </div>
            </div>

            <div v-if="item.cardNo" class="secret_line" :class="{ 'inconsistent': item.inconsistent }">{{ item.cardNo }}</div>
            <div v-if="item.cardPwd" class="secret_line" :class="{ 'inconsistent': item.inconsistent }">{{ item.cardPwd }}</div>
            <div v-if="item.cardText && (item.isVerified || item.orderStatus === 3)" class="order_done_tag">订单已完成</div>
            <div v-if="item.createTime" class="time_line">
              <span>下单时间</span>
              <span>{{ item.createTime }}</span>
            </div>
            <div v-if="!item.cardNo && !item.cardPwd" class="empty_tip">
              {{ item.cardStatus === '已退款' ? '卡密发放失败，订单金额已退回余额' : '卡密发放中，预计24小时内自动到账，请耐心等待' }}
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div v-if="selectMode" class="select_footer">
      <div class="select_all_wrap" @click="toggleSelectAll">
        <div class="select_all_check" :class="{ checked: allSelected }">
          <van-icon v-if="allSelected" name="success" />
        </div>
        <span class="select_all_text">全选</span>
        <span class="selected_count">已选 {{ checkedCount }} 张</span>
      </div>
      <div class="copy_selected_btn" @click="copySelected">一键复制</div>
    </div>

    <van-popup v-model="showMetaPopup" round class="meta_popup">
      <div class="popup_title">卡券信息</div>
      <div v-if="metaItem.categoryName" class="popup_row">
        <span>卡类</span>
        <span class="popup_value">{{ metaItem.categoryName }}</span>
      </div>
      <div v-if="metaItem.cardTypeName" class="popup_row">
        <span>卡种</span>
        <span class="popup_value">{{ metaItem.cardTypeName }}</span>
      </div>
      <div v-if="metaItem.faceValue" class="popup_row">
        <span>面值</span>
        <span class="popup_value">{{ metaItem.faceValue }}</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { List, PullRefresh, Empty, Popup, Icon, DropdownMenu, DropdownItem } from 'vant';

Vue.use(List).use(PullRefresh).use(Empty).use(Popup).use(Icon).use(DropdownMenu).use(DropdownItem);

export default {
  name: 'kamiInfo',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 30,
      showMetaPopup: false,
      metaItem: {},
      selectMode: false,
      // 筛选条件：''=全部，1=已核销，0=未核销
      filterVerified: '',
      // 筛选条件：''=全部，1=已生成卡密，0=未生成卡密
      filterHasCard: '',
      verifiedOptions: [
        { text: '全部核销状态', value: '' },
        { text: '已核销', value: '1' },
        { text: '未核销', value: '0' },
      ],
      hasCardOptions: [
        { text: '全部卡密状态', value: '' },
        { text: '已生成卡密', value: '1' },
        { text: '未生成卡密', value: '0' },
      ],
    };
  },
  computed: {
    checkedCount() {
      var count = 0;
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].checked) count++;
      }
      return count;
    },
    // 所有可勾选的卡券是否都已勾选
    allSelected() {
      var selectable = 0;
      var checked = 0;
      for (var i = 0; i < this.list.length; i++) {
        if (this.isSelectable(this.list[i])) {
          selectable++;
          if (this.list[i].checked) checked++;
        }
      }
      return selectable > 0 && checked === selectable;
    },
  },
  created() {
    this.$parent.footer('user', false);
  },
  methods: {
    pickValue(item, keys) {
      for (var i = 0; i < keys.length; i++) {
        var val = item[keys[i]];
        if (val !== undefined && val !== null && String(val).trim() !== '') {
          return String(val).trim();
        }
      }
      return '';
    },
    normalizeList(rows) {
      var result = [];
      for (var i = 0; i < rows.length; i++) {
        var item = rows[i] || {};
        if (parseInt(item.goods_type) !== 1) continue;
        // 支付失败订单没有卡密，跳过
        if (parseInt(item.status) === 4) continue;
        var cardNo = this.pickValue(item, ['card_no', 'card', 'kami', 'cardnum', 'kahao']);
        var cardPwd = this.pickValue(item, ['card_pwd', 'card_password', 'pwd', 'password', 'kamipwd', 'mima']);
        var cardText = [cardNo, cardPwd].filter(Boolean).join(' ');
        result.push({
          id: item.id,
          item_title: item.item_title || '',
          cardNo: cardNo,
          cardPwd: cardPwd,
          cardText: cardText,
          cardStatus: item.card_status || '',
          orderStatus: parseInt(item.status) || 0,
          createTime: item.create_time || '',
          categoryName: item.recycle_category_name || '',
          cardTypeName: item.recycle_card_type_name || '',
          faceValue: item.recycle_face_value || '',
          isVerified: parseInt(item.is_verified) === 1,
          checked: false,
          inconsistent: false,
        });
      }
      return result;
    },
    onLoad() {
      Fetch('/shop/orders', {
        page: this.page,
        page_size: this.pageSize,
        goods_type: 1,
        has_card: this.filterHasCard,
        is_verified: this.filterVerified
      }).then((r) => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        var res = r.data || {};
        var current = this.normalizeList(res.list || []);
        this.list = this.list.concat(current);
        this.loading = false;

        if ((res.list || []).length < this.pageSize) {
          this.finished = true;
        } else {
          this.page++;
        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    onRefresh() {
      this.finished = false;
      this.page = 1;
      this.loading = true;
      this.onLoad();
    },
    // 筛选条件变更：重置分页并从第一页重新加载
    onFilterChange() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.loading = true;
      this.onLoad();
    },
    showMeta(item) {
      this.metaItem = item || {};
      this.showMetaPopup = true;
    },
    // 进入选择模式
    enterSelectMode() {
      this.selectMode = true;
    },
    // 退出选择模式并清空勾选
    exitSelectMode() {
      this.selectMode = false;
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].checked = false;
      }
    },
    // 仅未核销且已生成卡密的卡券可勾选
    isSelectable(item) {
      return !!(item && item.cardText && !item.isVerified && item.orderStatus !== 3);
    },
    toggleCheck(item) {
      if (!item || !this.isSelectable(item)) return;
      item.checked = !item.checked;
      // 取消勾选时清除不一致标记
      if (!item.checked) item.inconsistent = false;
    },
    // 全选/取消全选：仅作用于当前可勾选的卡券
    toggleSelectAll() {
      var selectableCount = 0;
      for (var i = 0; i < this.list.length; i++) {
        if (this.isSelectable(this.list[i])) selectableCount++;
      }
      if (selectableCount === 0) return;
      var next = !this.allSelected;
      for (var j = 0; j < this.list.length; j++) {
        var item = this.list[j];
        if (this.isSelectable(item)) item.checked = next;
        item.inconsistent = false;
      }
    },
    // 一键复制：以被选中的第一张为准，勾选卡券须为同一卡类-卡种-面值，不一致的卡券用红色标记
    copySelected() {
      var selected = [];
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].checked) selected.push(this.list[i]);
      }
      if (selected.length === 0) {
        this.$toast('请先勾选要复制的卡券');
        return;
      }
      // 先清除上一次的不一致标记
      for (var k = 0; k < this.list.length; k++) {
        this.list[k].inconsistent = false;
      }
      var base = selected[0];
      var key = [base.categoryName, base.cardTypeName, base.faceValue].join('|');
      var hasInconsistent = false;
      for (var j = 1; j < selected.length; j++) {
        var cur = selected[j];
        var curKey = [cur.categoryName, cur.cardTypeName, cur.faceValue].join('|');
        if (curKey !== key) {
          // 与第一张不一致：红色标记该卡券的卡号卡密
          cur.inconsistent = true;
          hasInconsistent = true;
        }
      }
      if (hasInconsistent) {
        this.$toast('存在卡类-卡种-面值不一致的卡券，已用红色标记，请取消勾选后再试');
        return;
      }
      // 同一卡类-卡种-面值，每行一张批量复制
      var text = selected.map(function (s) { return s.cardText; }).join('\n');
      this.copyText(text);
    },
    copyText(text) {
      text = String(text || '');
      if (!text) {
        this.$toast('暂无可复制内容');
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast('复制成功');
        }).catch(() => {
          this.fallbackCopy(text);
        });
        return;
      }
      this.fallbackCopy(text);
    },
    fallbackCopy(text) {
      var input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast('复制成功');
    }
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  padding-top: 60px;
  min-height: 100vh;
  background: #F3F3F5;
}
.page_header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  z-index: 20;
  background: url(../../assets/images/red_bg.png) no-repeat center center;
  background-size: 100% 100%;
}
.header_inner {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back_left {
  position: absolute;
  left: 0;
  top: 14px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: url(../images/item/back.png) no-repeat center center;
  background-size: auto 100%;
}
.big_tit {
  font-size: 17px;
  font-weight: 600;
  color: #FFFFFF;
}
.header_action {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  min-width: 52px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.25);
  color: #FFFFFF;
  font-size: 14px;
}
.content_box {
  padding: 12px 10px 16px;
}
.filter_menu {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
}
.content_box.has_footer {
  padding-bottom: 90px;
}
.kami_card {
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0px 2px 10px rgba(31, 35, 41, 0.08);
}
.card_head {
  min-height: 54px;
  padding: 12px 12px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #5b8cff 0%, #7b67df 100%);
}
.item_title {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #FFFFFF;
  padding-right: 12px;
}
.check_icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: transform 0.1s;
  &:active {
    transform: scale(0.9);
  }
  &.checked {
    border-color: #FFFFFF;
    background: #FFFFFF;
    color: #5b8cff;
    font-size: 14px;
  }
}
.copy_all_btn {
  flex-shrink: 0;
  min-width: 84px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.95);
  color: #6a61d8;
  font-size: 14px;
}
.head_btns {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.info_icon {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: #FFFFFF;
  font-size: 16px;
}
.secret_line {
  padding: 14px 12px 0;
  font-size: 16px;
  line-height: 24px;
  color: #1F2329;
  word-break: break-all;
  &.inconsistent {
    color: #EE0A24;
  }
}
.secret_line:last-of-type {
  padding-bottom: 14px;
}
.empty_tip {
  padding: 16px 12px;
  font-size: 14px;
  line-height: 22px;
  color: rgba(31, 35, 41, 0.55);
}
.order_done_tag {
  margin: 8px 12px 12px;
  padding: 6px 0;
  font-size: 13px;
  font-weight: 600;
  color: #18B566;
}
.time_line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding: 10px 12px;
  font-size: 12px;
  color: rgba(31, 35, 41, 0.45);
  border-top: 1px solid #F0F1F3;
}
.meta_popup {
  width: 78%;
  max-width: 340px;
  padding: 20px 18px 22px;
}
.popup_title {
  font-size: 17px;
  font-weight: 600;
  color: #1F2329;
  text-align: center;
  margin-bottom: 14px;
}
.popup_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 4px;
  font-size: 14px;
  &:not(:last-child) {
    border-bottom: 1px solid #F2F3F5;
  }
  & > span:first-child {
    color: rgba(31, 35, 41, 0.55);
  }
}
.popup_value {
  color: #1F2329;
  font-weight: 600;
}
.select_footer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  height: 60px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF;
  border-top: 1px solid #F0F1F3;
  z-index: 20;
}
.select_all_wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.select_all_check {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid rgba(31, 35, 41, 0.35);
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: transform 0.1s;
  &:active {
    transform: scale(0.9);
  }
  &.checked {
    border-color: #5b8cff;
    background: #5b8cff;
    color: #FFFFFF;
    font-size: 12px;
  }
}
.select_all_text {
  font-size: 14px;
  color: rgba(31, 35, 41, 0.85);
}
.selected_count {
  font-size: 14px;
  color: rgba(31, 35, 41, 0.75);
}
.copy_selected_btn {
  min-width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 20px;
  background: linear-gradient(90deg, #5b8cff 0%, #7b67df 100%);
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 600;
  transition: transform 0.1s;
  &:active {
    transform: scale(0.98);
  }
}
</style>
